'use client'

/**
 * HyperDX User Sync Component
 *
 * Automatically syncs NextAuth user data to HyperDX for session tracking.
 * This component should be placed in the root layout to ensure user data
 * is attached to all HyperDX sessions after authentication.
 */

import { useEffect, useRef } from 'react'
import { useSession } from 'next-auth/react'
import { attachUserInfo } from './HyperDXClient'

export function HyperDXUserSync() {
  const { data: session, status } = useSession()
  const lastAttachedRef = useRef<string | null>(null)

  // Deps primitivas evitam rajada: NextAuth reemite o objeto session em
  // foreground/polling/refresh — com dep [session] o attach disparava
  // múltiplas vezes por sessão, criando rajada de spans OTEL.
  const userId = session?.user?.id ? String(session.user.id) : null
  const email = session?.user?.mail || session?.user?.email || undefined
  const name = session?.user?.fullName || session?.user?.name || undefined
  const role = session?.user?.role
  const companyId = session?.user?.companyId
  const companyName = session?.user?.companyName
  const farmCount = session?.user?.farmList?.length || 0

  useEffect(() => {
    if (status !== 'authenticated' || !userId) return
    if (lastAttachedRef.current === userId) return

    lastAttachedRef.current = userId
    attachUserInfo({
      userId,
      userEmail: email,
      userName: name,
      userRole: role,
      companyId,
      companyName,
      farmCount,
    })
  }, [status, userId, email, name, role, companyId, companyName, farmCount])

  return null
}
